// advance-search/types.ts
export type FieldType =
  | "text"
  | "number"
  | "date"
  | "datetime"
  | "datemonth"
  | "checkbox"
  | "dropdown"
  | "lookup"
  | "uuid"
  | "json";

export type Option = { value: string; label: string };

export interface FieldSchemaBase<T extends FieldType> {
  name: string;
  type: T;
  label?: string;
  multiTableSearch?: boolean;
  lookupFieldName?: string;
}

export interface DropdownFieldSchema extends FieldSchemaBase<"dropdown"> {
  options: Option[];
}
export type TextFieldSchema = FieldSchemaBase<"text">;
export type NumberFieldSchema = FieldSchemaBase<"number">;
export type DateFieldSchema = FieldSchemaBase<"date">;
export type DateTimeFieldSchema = FieldSchemaBase<"datetime">;
export type DateMonthFieldSchema = FieldSchemaBase<"datemonth">;
export type CheckboxFieldSchema = FieldSchemaBase<"checkbox">;
export interface LookupFieldSchema extends FieldSchemaBase<"lookup"> {
  maxTags?: number;
  fetchSuggestions?: (query: string) => Promise<Option[]>;
  suggestionDebounce?: number;
  placeholder?: string;
  noOptionsMessage?: string;
  loadingMessage?: string;
}
export type UUIDFieldSchema = FieldSchemaBase<"uuid">;
export interface JSONFieldSchema extends FieldSchemaBase<"json"> {
  jsonPath?: string[];
  maxTags?: number;
  fetchSuggestions?: (query: string) => Promise<Option[]>;
  suggestionDebounce?: number;
  placeholder?: string;
  noOptionsMessage?: string;
  loadingMessage?: string;
}

export type FieldSchema =
  | DropdownFieldSchema
  | TextFieldSchema
  | NumberFieldSchema
  | DateFieldSchema
  | DateTimeFieldSchema
  | DateMonthFieldSchema
  | CheckboxFieldSchema
  | LookupFieldSchema
  | UUIDFieldSchema
  | JSONFieldSchema;

// ตัวดำเนินการทั้งหมดที่รองรับ
export type OperatorValue =
  | "contains"
  | "equals"
  | "beginsWith"
  | "endsWith"
  | "notEquals"
  | "notBeginsWith"
  | "notEndsWith"
  | "notContains"
  | "gt"
  | "gte"
  | "lt"
  | "lte"
  | "on"
  | "after"
  | "before"
  | "between"
  | "is"
  | "isNot"
  | "containsAny"
  | "containsOnly"
  | "containsAll";

// ใช้เป็น source of truth สำหรับ label
export const OPERATOR_LABEL: Record<OperatorValue, string> = {
  contains: "Contains",
  equals: "Equals",
  beginsWith: "Begins with",
  endsWith: "Ends with",
  notEquals: "Not equals",
  notBeginsWith: "Not begins with",
  notEndsWith: "Not ends with",
  notContains: "Not contains",
  gt: "Greater than",
  gte: "Greater or equal",
  lt: "Less than",
  lte: "Less or equal",
  on: "On",
  after: "After",
  before: "Before",
  between: "Between",
  is: "Is",
  isNot: "Is not",
  containsAny: "Contains at least one of",
  containsOnly: "Contains only",
  containsAll: "Contains all of"
};

export type RowState =
  | {
      id: string;
      fieldName: string;
      fieldType: FieldType;
      operator: Exclude<OperatorValue, "between">;
      value: string | any[];
      value2?: undefined;
      multiTableSearch?: boolean;
      jsonPath?: string[];
      lookupFieldName?: string;
    }
  | {
      id: string;
      fieldName: string;
      fieldType: FieldType;
      operator: "between";
      value: string; // ช่องจาก
      value2: string; // ช่องถึง
      multiTableSearch?: boolean;
      jsonPath?: string[];
      lookupFieldName?: string;
    };

export interface Params {
  AND: Record<string, unknown>[];
}

export interface AdvanceSearchProps {
  fields: FieldSchema[];
  portalId: string;
  limitRows?: number;
  iconColor?: string;
  onSearch?: (param: Params) => void;
  onClear?: () => void;
  shortDateFormat?: string;
}

export interface ParamsBuilder {
  build(row: RowState): object;
}
